module.exports = __webpack_public_path__ + "img/full7-min.dbac6856.png";